import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import { AttachmentList } from "Attachment/index";
import {
  getAutoCheckSimilaritySettingName,
  getCurrentProjectGroupDetails,
} from "Projects/modules/ProjectModules";
import { getSettingValue } from "modules/PermissionModule";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";
import SimilarityIndexComponent from "AppComponents/SimilarityIndexComponent";

const TEST_ID_PREFIX = "projects-attachment-list";

const ProjectsAttachmentList = props => {
  const styles = {
    attachmentContainerStyle: {
      display: "flex",
      flexDirection: "column",
      gap: "12px",
    },
  };

  const {
    value,
    activeAttachment,
    isEditMode,
    showCreateDropDown = false,
    shouldCallMutation = false,
    showAttachmentInfo,
    showDeleteModal,
    alwaysShowActions,
    onClickAttachmentCard,
    onDeleteAttachmentCallback,
    renameAttachmentCallBack,
    mode,
    attachmentContainerStyle: attachmentContainerStyleProps,
    mediaCardSize,
    dropdownIconButtonSize,
    showSimilarity = true,
    projectId,

    projectGroupSubType,
    projectGroupType,
    organizationId,
    projectGroupId,
    userEntityType,
    userId,
    currentCurriculumProgramId,
    currentCurriculumProgramType,
    autoCheckSimilarityRef,
    showEditResponseButton,
    showPdfTronEditButton,
    onEditAttachmentClick,
    togglePdfTronEditButton,
    getAttachmentExtraIconButtons = () => {},
    showAttachmentExtraIconButtons = () => {},
    showNewTabOption,
    getViewModeExtraButtons,
    showIconButton,
  } = props;

  const isAutoSimilarityCheckEnabled = showSimilarity
    ? getSettingValue({
        name: getAutoCheckSimilaritySettingName({
          projectGroupSubType,
          curriculumProgramType: currentCurriculumProgramType,
        }),
        organizationId,
        userEntityType,
        userId,
        currentCurriculumProgramId,
      })
    : false;

  const attachmentBottomComponent = params => {
    const {
      attachment,
      recheckButtonHoverClass,
      showSimilarityOnHeader = false,
    } = params;
    return !_.isEmpty(attachment) ? (
      <SimilarityIndexComponent
        metadata={{
          entityId: projectId,
          entityType: "PROJECT",
        }}
        attachment={attachment}
        recheckButtonHoverClass={recheckButtonHoverClass}
        showSimilarityOnHeader={showSimilarityOnHeader}
        projectGroupType={projectGroupType}
        projectGroupId={projectGroupId}
        buttonVariant={"neutral"}
        buttonType={"inline"}
        customRef={isAutoSimilarityCheckEnabled ? autoCheckSimilarityRef : null}
        sourceFrom={"PROJECTS"}
      />
    ) : null;
  };

  return (
    <AttachmentList
      cardType={"design-media-card"}
      dsVersion="2.0"
      value={value}
      showCreateDropDown={showCreateDropDown}
      shouldCallMutation={false}
      mode={mode}
      renderCreateDropdown={false}
      onClickAttachmentCard={onClickAttachmentCard}
      onDeleteAttachmentCallback={onDeleteAttachmentCallback}
      renameAttachmentCallBack={renameAttachmentCallBack}
      activeAttachment={activeAttachment}
      attachmentContainerStyle={
        attachmentContainerStyleProps
          ? attachmentContainerStyleProps
          : styles.attachmentContainerStyle
      }
      alwaysShowActions={alwaysShowActions}
      showDeleteModal={showDeleteModal}
      showAttachmentInfo={showAttachmentInfo}
      mediaCardSize={mediaCardSize}
      dropdownIconButtonSize={dropdownIconButtonSize}
      attachmentBottomComponent={
        showSimilarity ? attachmentBottomComponent : null
      }
      showEditResponseButtonProps={showEditResponseButton}
      showPdfTronEditButton={showPdfTronEditButton}
      onEditAttachmentClick={onEditAttachmentClick}
      toggleMediaModalProps={togglePdfTronEditButton}
      showAttachmentExtraIconButtons={showAttachmentExtraIconButtons}
      getAttachmentExtraIconButtons={getAttachmentExtraIconButtons}
      showNewTabOption={showNewTabOption}
      getViewModeExtraButtons={getViewModeExtraButtons}
      showIconButton={showIconButton}
      testId={TEST_ID_PREFIX}
    />
  );
};

const mapStateToProps = state => {
  const projectGroupDetails = getCurrentProjectGroupDetails({ state });
  const {
    type: projectGroupType,
    id: projectGroupId,
    subType: projectGroupSubType,
  } = projectGroupDetails;

  const userInfo = getUserInfo();
  const { organizationId, userEntityType, userId } = userInfo;

  const currentCurriculumProgramType = _.get(
    state,
    "platform.currentCurriculumProgram.type",
    ""
  );

  const currentCurriculumProgramId = _.get(
    state,
    "platform.currentCurriculumProgram.id",
    null
  );

  return {
    projectGroupType,
    projectGroupId,
    projectGroupSubType,
    organizationId,
    userEntityType,
    userId,
    currentCurriculumProgramId,
    currentCurriculumProgramType,
  };
};

export default connect(mapStateToProps)(ProjectsAttachmentList);
